<template>
  <div class="text-center">
    <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
  </div>
</template>
<script>
export default {
  name: "LoaderPage"
};
</script>
